import * as Joi from 'joi';
import { getJoiObject } from '../../../../utils/JoiUtils';

const AddSubjectModalSchema = () =>
  Joi.object({
    explanation: 'test explanation using api',
    examLevel: getJoiObject(
      Joi.string().required().messages({
        'any.required': 'Exam Level is not allowed to be empty.',
        'string.base': 'Exam Level is not allowed to be empty.',
      })
    ),
    examSeries: getJoiObject(
      Joi.string().required().messages({
        'any.required': 'Exam Series is not allowed to be empty.',
        'string.base': 'Exam Series is not allowed to be empty.',
      })
    ),
  });

export default AddSubjectModalSchema;
